export const game = {
    qxdj: {
        plate: "",
        coupon: "qxdj",
        title: "里程兑换轻喜到家优惠券",
        banner: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/qxdj/banner.png",
        jingle: "",
        icon: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/qxdj/logo.png",
        name: "轻喜到家",
        coupon_type: "优惠券",
        productImg: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/qxdj/product.png",
        productImgAvatar: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/qxdj/icon.png",
        recharge_tabs_img: [require('@/assets/images/qxdj/recharge.png'), require('@/assets/images/qxdj/write.png')],
        recharge_image_content: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/qxdj/rechargeContents.png",
        store_images: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/qxdj/stores.jpg",
        headerImg: require("@/assets/images/qxdj/header-top.png"),
        order_card: require("@/assets/images/qxdj/order-card.png"),
        // unit: "",
        input_tag: "充值账号",
        isIos: true,
        tips: "输入的手机号将自动注册为轻喜到家会员",
        placeholder: "请输入轻喜到家会员手机号",
        rechargeText: [
            {
                name: "",
                titles: [
                    "里程兑换商品不提供报销凭证，一经兑换，不可退换、转售、兑现、找零、拆分使用；",
                    '本优惠券兑换后系统自动发放到“轻喜到家”对应手机号码账户内，请<span class="required">确保手机号填写正确</span>，因预留手机号填写错误造成的损失由会员本人承担；',
                    '优惠券查看方式：<p>轻喜到家(微信小程序)-我的-优惠券；</p>',
                    '本优惠券不限兑换次数，请注意兑换后在有效期内使用，过期作废；',
                    '若填写的手机号未注册轻喜到家会员，兑换成功后系统将自动注册该手机号码为轻喜到家会员并完成充值；',
                    '如需帮助，请拨打客服热线：4000-360-195。'
                ]
            },
            {
                name: "使用说明",
                titles: [
                    '使用规则：无门槛使用，单笔订单限用1张，1张优惠券仅支持一次性消费，不找零不折现，不与其他优惠叠加使用；',
                    '本优惠券仅限在“轻喜到家”官方小程序内使用,可用优惠券产品请以轻喜到家小程序内当前产品说明为主，此优惠券不可用产品为:包年和月嫂、育婴等非定价产品；',
                    '优惠券使用方式：支付时选择对应优惠券，完成支付，补差部分请使用其他方式完成支付；',
                    '优惠券有效时间：<span class="required">领取后90日内有效</span>，过期不再补发，自动作废；',
                    '“轻喜到家”家政服务覆盖城市详情，<a style="color: #0053DC" href="./stores">请点击查看</a>。因服务范围存在变更，具体以轻喜到家小程序内显示为准。<p style="margin-top: 20px">温馨提示：</p>“轻喜到家”相关家政服务需提前2天预约，预约入口：微信公众号-轻喜到家-预约服务（右下角）。<p>本平台仅是提供会员与商户之间的兑换服务平台，如遇服务质量问题，请及时与商户联系。</p><p>咨询及投诉：19007563705（卢经理）</p>'
                ]
            }
        ],
        successImg: require('@/assets/images/qxdj/success.png'),
        //项目基础样式
        style: {
            "--view-banner-padding":"0",
            //兑换记录按钮文字
            "--view-exchange-color": "#0053DC",
            //背景颜色
            "--view-background-color": "#B6D9FF",
            //版权文字颜色
            "--view-copy-right-color": "#2B71E3",
            //兑换须知背景
            "--view-recharg-background-color": "#B6D9FF",
            //产品边框颜色
            "--view-product-lst-border-color": "#E41D1A",
            //产品兑换按钮背景
            "--view-product-value-background-color": "linear-gradient(175deg,#FF5849 35%, #FFEB3B 100%)",
            //#808080  #E5E5E5
            "--view-product-value-background-fail-color": "linear-gradient(175deg,#808080 35%, #E5E5E5 100%)",
            //产品兑换按钮文字
            // "--view-product-value-color": "#8200A1",
            //产品兑换按钮文字
            // "--view-product-user-pay-account-tips": "#FDAD00",
            //产品兑换按钮文字
            // "--view-product-user-pay-account-tips-border": "1px solid #FDAD00",
            //兑换成功文字
            '--view-product-success-color': '#3175E2',
            //兑换成功按钮
            '--view-product-success-btn-success-background': '#314FAD',
            //兑换成功按钮
            '--view-product-success-btn-success-color': '#ffffff',
            //兑换成功按钮
            '--view-product-success-btn-cancel-background': '#D1D1D1',
            //兑换成功按钮
            '--view-product-success-btn-cancel-color': '#000000',
        }
    },
    kaojiang: {
        plate: "",
        coupon: "kaojiang",
        title: "里程兑换烤匠代金券",
        banner: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/kaojiang/banner.png",
        jingle: "",
        icon: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/kaojiang/logo.png",
        name: "烤匠代金券",
        coupon_type: "无门槛可叠加使用",
        productImg: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/kaojiang/product.png",
        productImgAvatar: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/kaojiang/logo.png",
        recharge_tabs_img: [require('@/assets/images/kaojiang/recharge.png'), require('@/assets/images/kaojiang/write.png')],
        recharge_image_content: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/kaojiang/rechargeContents.png",
        store_images: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/qxdj/stores.jpg",
        headerImg: require("@/assets/images/kaojiang/header-top.png"),
        order_card: require("@/assets/images/qxdj/order-card.png"),
        // unit: "",
        input_tag: "充值账户",
        isIos: true,
        tips: "输入的手机号将自动注册为烤匠会员",
        placeholder: "请输入充值手机号",
        rechargeText: [
            {
                name: "",
                titles: [
                    "里程兑换商品不提供报销凭证，一经兑换不可退换、转售、兑现、找零、拆分使用，可转赠给他人使用；",
                    '本券兑换成功后，系统将自动发放到兑换时填写的手机号，<span class="required">请确保手机号填写正确</span>，因手机号码填写错误造成的损失由会员本人承担；',
                    '若填写的手机号未注册烤匠会员，兑换成功后系统将自动注册填写手机号为烤匠会员并完成充值；',
                    '如需帮助，请拨打客服热线：4000-360-195。'
                ]
            },
            {
                name: "代金券使用说明",
                titles: [
                    '适用门店:适用于烤匠线下门店，门店地址及联系电话请<a style="color: #0053DC" href="./stores">点击查看</a>；',
                    '有效期：自兑换成功之日起<span class="required">60天内有效</span>，请在有效期内使用，过期自动作废不可补发且里程不可退；',
                    '使用规则:本券为一次性使用券，全场无门槛使用(仅限堂食)，可叠加多张同时使用，不找零不折现，不与店内其他优惠同享；使用后不可退，无需预约，用餐人数太多时需等位；',
                    '查看方式：请用兑换时填写的手机号登录“烤匠麻辣烤鱼线上点餐”小程序-我的-优惠券查看；或在“烤匠”公众号-会员中心-会员卡查看；',
                    '本平台仅是提供会员与商户之间的服务平台，如遇商品质量问题，请及时与商户联系。'
                ]
            }
        ],
        successImg: require('@/assets/images/kaojiang/success.png'),
        //项目基础样式
        style: {
            "--view-banner-padding":"15px 10px",
            //兑换记录按钮文字
            "--view-exchange-color": "#F46C6E",
            //背景颜色
            "--view-background-color": "#F3EBDD",
            //版权文字颜色
            "--view-copy-right-color": "#000",
            //兑换须知背景
            "--view-recharg-background-color": "#000000",
            //产品边框颜色
            "--view-product-lst-border-color": "#fff",
            //产品兑换按钮背景
            "--view-product-value-background-color": "#D53030",
            //#808080  #E5E5E5
            "--view-product-value-background-fail-color": "#616161",
            //产品兑换按钮文字
            // "--view-product-value-color": "#8200A1",
            //产品兑换按钮文字
            // "--view-product-user-pay-account-tips": "#FDAD00",
            //产品兑换按钮文字
            // "--view-product-user-pay-account-tips-border": "1px solid #FDAD00",
            //兑换成功文字
            '--view-product-success-color': '#FF8E1A',
            //兑换成功按钮
            '--view-product-success-btn-success-background': 'linear-gradient(0deg,#D32929 35%,  #FFC300 100%)',
            //兑换成功按钮
            '--view-product-success-btn-success-color': '#ffffff',
            //兑换成功按钮
            '--view-product-success-btn-cancel-background': '#D1D1D1',
            //兑换成功按钮
            '--view-product-success-btn-cancel-color': '#000000',
        }
    },
    mos: {
        plate: "",
        coupon: "mosuannai",
        title: "川航金熊猫会员兑换茉酸奶代金券",
        banner: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/mos/banner.png",
        jingle: "",
        icon: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/mos/logo.png",
        name: "茉酸奶代金券",
        coupon_type: "无门槛使用",
        productImg: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/kaojiang/product.png",
        productImgAvatar: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/mos/logo.png",
        recharge_tabs_img: [require('@/assets/images/mos/recharge.png'), require('@/assets/images/mos/write.png')],
        recharge_image_content: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/mos/rechargeContents.png",
        store_images: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/qxdj/stores.jpg",
        headerImg: require("@/assets/images/kaojiang/header-top.png"),
        order_card: require("@/assets/images/qxdj/order-card.png"),
        // unit: "",
        input_tag: "充值账号",
        isIos: true,
        tips: "输入的手机号将自动注册为烤匠会员",
        placeholder: "请输入充值手机号",
        rechargeText: [
            {
                name: "",
                titles: [
                    "里程兑换商品不提供报销凭证，兑换成功不可退换，转售、兑现、找零、拆分使用；",
                    '本券兑换成功后，系统将自动发放到兑换时填写的手机号，<span class="required">请确保手机号填写正确</span>，因手机号码填写错误造成的损失由会员本人承担；',
                    '若填写的手机号未注册茉酸奶会员，兑换成功后系统将自动注册填写手机号为茉酸奶会员并完成充值；',
                    '如需帮助，请拨打客服热线：4000-360-195。'
                ]
            },
            {
                name: "代金券使用说明",
                titles: [
                    '代金券有效期：自兑换成功之日起30天内有效，请在有效期内使用，过期作废，不退不补；',
                    '适用商品：酸奶奶昔产品；',
                    '适用门店：茉酸奶线下门店，可用门店地址<a style="color: #0053DC" href="./stores">请点击查看</a>，交通枢纽、景区、部分商场等特殊门店除外；',
                    '适用场景：本券<span class="required">仅限“茉酸奶点单小程序”下单时使用</span>:' +
                    '<p>①本券不与其他优惠活动及优惠券同时使用；</p>' +
                    '<p>②单笔订单最多使用2张代金券；</p>' +
                    '<p>③本券仅限个人使用，不可转赠他人；</p>' +
                    '<p>④用户不得以不合法、不正当、不诚信的方式领券（包括但不限于利用外挂、作弊工具或其他技术手段恶意套取免单券、虚假交易、刷单等），否则茉酸奶有权撤销用户的参与资格，并有权回收非法所得的权益；</p>' +
                    '<p>⑤成功领取后，用户可以在茉酸奶点单小程序-优惠券中查看券的详细使用规则和权益；</p>',
                    '本平台仅是提供会员与商户之间的服务平台，如遇商品质量问题请及时与商户联系。'
                ]
            }
        ],
        successImg: require('@/assets/images/kaojiang/success.png'),
        //项目基础样式
        style: {
            "--view-banner-padding":"15px 10px",
            //兑换记录按钮文字
            "--view-exchange-color": "#F46C6E",
            //背景颜色
            "--view-background-color": "#C1D2CA",
            //版权文字颜色
            "--view-copy-right-color": "#003615",
            //兑换须知背景
            "--view-recharg-background-color": "#00502B",
            //产品边框颜色
            "--view-product-lst-border-color": "#fff",
            //产品兑换按钮背景
            "--view-product-value-background-color": "#D53030",
            //#808080  #E5E5E5
            "--view-product-value-background-fail-color": "#616161",
            //产品兑换按钮文字
            // "--view-product-value-color": "#8200A1",
            //产品兑换按钮文字
            // "--view-product-user-pay-account-tips": "#FDAD00",
            //产品兑换按钮文字
            // "--view-product-user-pay-account-tips-border": "1px solid #FDAD00",
            //兑换成功文字
            '--view-product-success-color': '#FF8E1A',
            //兑换成功按钮
            '--view-product-success-btn-success-background': 'linear-gradient(0deg,#D32929 35%,  #FFC300 100%)',
            //兑换成功按钮
            '--view-product-success-btn-success-color': '#ffffff',
            //兑换成功按钮
            '--view-product-success-btn-cancel-background': '#D1D1D1',
            //兑换成功按钮
            '--view-product-success-btn-cancel-color': '#000000',
        }
    },
}

// function showCityLst(){
//     alert("服务覆盖城市地区详情：北京、上海、广州、深圳、杭州、东莞、南京、苏州、成都、武汉、重庆、宁波、无锡、佛山、珠海、合肥、郑州、西安、长沙、济南、南昌、绍兴、石家庄、惠州、昆山、大连、温州、天津、青岛、常州、南通、昆明、嘉兴、厦门、福州、扬州、南宁、贵阳、中山、湖州、金华、江阴、徐州、盐城、泰州、漳州、台州")
//
// }
